import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const LineGraph20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      d='M16.376 7.05639L19.6144 2.43011L18.3856 1.56992L15.278 6.00933L12.8024 4.59469C12.2068 4.25434 11.4481 4.4576 11.1025 5.05016L8.22672 9.98003L5.77733 8.58038C5.20692 8.25443 4.48152 8.42567 4.1171 8.97231L0.375977 14.584L1.62405 15.416L5.23573 9.99852L7.69765 11.4053C8.29326 11.7457 9.05189 11.5424 9.39754 10.9499L12.2733 6.01999L14.7318 7.42486C15.2928 7.7454 16.0056 7.58566 16.376 7.05639Z'
      fill='currentColor'
    />
    <path d='M20 17.25H0V18.75H20V17.25Z' fill='currentColor' />
  </Svg>
);

LineGraph20.displayName = 'LineGraph20';
export default LineGraph20;
